/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Definitietoestand van één Human Design-center, gepromoveerd uit de
 * frontend-berekende propertiesSummary in de chart-document-JSON.
 * Unknown (0) betekent: document is nog niet gestampt (oude chart,
 * nog geen backfill) — bewust non-nullable met default 0, zodat de
 * bestaande INTEQUALS-filteroperator er direct op werkt (beslispunt B5).
 *
 * 0 = Unknown
 * 1 = Open
 * 2 = Undefined
 * 3 = Defined
 */
export enum PlatformHdCenterState {
  Unknown = 0,
  Open = 1,
  Undefined = 2,
  Defined = 3
}
